function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M49.2024 21.2208C49.7906 21.0632 50.3981 21.4119 50.5254 22.0073C51.6105 27.0846 50.8232 32.398 48.2861 36.9562C45.5698 41.8365 41.061 45.4681 35.7142 47.0824C30.3673 48.6967 24.6021 48.167 19.639 45.6053C14.6759 43.0436 10.9044 38.6512 9.12296 33.3577C7.34151 28.0642 7.6899 22.2852 10.0944 17.244C12.4989 12.2029 16.7708 8.29532 22.0057 6.34847C27.2406 4.40162 33.0277 4.56833 38.1419 6.81329C42.9187 8.91016 46.7582 12.6664 48.9636 17.3667C49.2223 17.9179 48.9492 18.563 48.3854 18.7931L38.8226 22.6956C38.2588 22.9256 37.621 22.6507 37.3235 22.1194C36.3758 20.4267 34.8985 19.0775 33.104 18.2898C30.9712 17.3536 28.5577 17.284 26.3745 18.096C24.1914 18.9079 22.4098 20.5375 21.407 22.6399C20.4042 24.7423 20.2589 27.1523 21.0019 29.36C21.7448 31.5676 23.3177 33.3994 25.3875 34.4678C27.4574 35.5361 29.8617 35.757 32.0916 35.0838C34.3214 34.4105 36.2018 32.896 37.3346 30.8607C38.2877 29.1484 38.6487 27.1805 38.3802 25.2592C38.2959 24.6562 38.6377 24.0516 39.2259 23.894L49.2024 21.2208Z",
  fill: "url(#paint0_linear)",
  fillOpacity: 0.8
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M42.3696 19.7119C42.9031 19.5689 43.4541 19.8852 43.5695 20.4252C44.5537 25.0302 43.8396 29.8493 41.5385 33.9835C39.0749 38.4098 34.9855 41.7036 30.1361 43.1677C25.2866 44.6319 20.0577 44.1514 15.5563 41.828C11.0549 39.5047 7.63421 35.5208 6.01847 30.7197C4.40273 25.9186 4.71872 20.6772 6.89954 16.105C9.08037 11.5328 12.9548 7.98876 17.7028 6.22301C22.4508 4.45726 27.6995 4.60846 32.3379 6.64459C36.6704 8.5464 40.1528 11.9532 42.153 16.2163C42.3876 16.7162 42.1399 17.3013 41.6286 17.51L32.9553 21.0494C32.444 21.2581 31.8655 21.0088 31.5957 20.5269C30.7361 18.9917 29.3963 17.768 27.7687 17.0535C25.8343 16.2044 23.6454 16.1413 21.6653 16.8777C19.6851 17.6141 18.0693 19.0921 17.1598 20.9989C16.2503 22.9057 16.1185 25.0916 16.7924 27.0939C17.4662 29.0961 18.8928 30.7576 20.7701 31.7265C22.6474 32.6955 24.828 32.8959 26.8505 32.2853C28.8729 31.6746 30.5783 30.301 31.6058 28.4551C32.4702 26.902 32.7976 25.1172 32.5541 23.3746C32.4776 22.8277 32.7877 22.2793 33.3211 22.1364L42.3696 19.7119Z",
  fill: "#055445",
  fillOpacity: 0.6
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 46.5,
  y1: -0.00000378744,
  x2: 14.5,
  y2: 43,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F2995A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2995A",
  stopOpacity: 0
})));

function SvgUpTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 56 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpTime);
export default __webpack_public_path__ + "static/media/upTime.d4df343c97f5f6f4f530e43c1f11a2af.svg";
export { ForwardRef as ReactComponent };